import React from 'react';
export const usePageInfo = ({ page, perPage, total }) => {
    const from = page * perPage + 1;
    const to = Math.min(total, (page + 1) * perPage);
    return React.useMemo(() => ({
        from,
        to,
        total,
    }), [from, to, total]);
};
